import fetch from '@/fetch'
// 已预约的活动列表
export const activityAppointmentListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/console/h5/activity/getuserappointment',
    data: params,
    actionTypeCode: '24',
    actionTypeDesc: '已预约活动列表获取',
  })
}
// 已收藏的活动列表
export const activityFavoriteListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/console/h5/activity/getuserfavorites',
    data: params,
    actionTypeCode: '25',
    actionTypeDesc: '已收藏活动列表获取',
  })
}
